import { useEffect } from "react";
import { getAxiosWithHeaders } from "@/utils";
import { clickAnalyticsUrl } from "@/config";

function getOrCreateTabId() {
  const KEY = "kuick-uTabId";
  let existing = sessionStorage.getItem(KEY);
  //   TODO: Add session ID on state management
  if (!existing) {
    existing = String(Date.now()) + String(Math.floor(Math.random() * 1e6));
    sessionStorage.setItem(KEY, existing);
  }
  return existing;
}


export default function useOnClickAnalytics() {
  useEffect(() => {
    const uTabId = getOrCreateTabId();

    const handleClick = (event) => {
      const target = event.target;

      // Find nearest "actionable" element
      const clickable = target.closest(
        "button, a, [role='button'], [data-analytics], [data-ng-click]"
      );
      if (!clickable) return;

      // ---- ngClick (function name / marker) ----
      // Priority:
      // 1. data-ng-click
      // 2. data-analytics
      // 3. fallback tag + text
      const attrNgClick =
        clickable.getAttribute("data-ng-click") ||
        clickable.getAttribute("data-analytics");
      const fallbackNgClick = `${clickable.tagName.toLowerCase()}Click`;
      const ngClick = attrNgClick || fallbackNgClick;

      // ---- ngText (button/link text) ----
      let ngText = clickable.innerText || clickable.textContent || "";
      ngText = ngText.trim().slice(0, 80); // limit length

      // ---- ngCurpage (current page) ----
      // You can replace this with route name if you have one
      const ngCurpage = window.location.pathname || "Unknown";

      // ---- uTabId (session-scoped id) ----
      // Already generated once per tab above

      // Fire the API (no await to avoid blocking UI)
      sendClickAnalytics({ ngClick, ngText, ngCurpage, uTabId });
    };

    document.addEventListener("click", handleClick, true);

    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, []);
}


export const sendClickAnalytics = async ({
  ngClick,
  ngText,
  ngCurpage,
  uTabId,
}) => {
  try {
    const payload = {
      inputData: {
        ngClick,
        ngText,
        ngCurpage,
        uTabId,
      },
    };

    const { data, status } = await getAxiosWithHeaders().post(clickAnalyticsUrl, payload);

    // Optional: remove this in prod or switch to debug flag
    console.log("clickAnalytics response", { status, data });

    return { status, data };
  } catch (error) {
    console.error("clickAnalytics error", error);
    // You can choose to swallow or rethrow
    // throw error;
    return { status: null, error };
  }
};
